  export interface SalesCalendar {
    month: Date;
    startDate: Date;
    endDate: Date;
    sellingDays: number;
    salesYear: number;
  }

  export interface SalesTarget {
    month: Date;
    modelClass: string;
    modelCode: string;
    modelYear: number;
    target: number;
    created: Date;
    modified: Date;
    modifiedBy: number;

  }

  export interface ReportingVehicle {
    modelClass: string;
    modelCode: string;
    modelYear: number;
    bodyStyle: string;
    active: boolean;
    created: Date;
    modified: Date;
  }


  export interface ManagementRequestModel {
    pageSize: number;
    pageNumber: number;
    orderBy?: string;
    orderAscending?: boolean;
    searchTerm?: string;
    filter?: string;
    year?: number;
  }

  export interface ManagementResponseModel {
    pageLength: number;
    pageNumber: number;
    totalRecords: number;
    maxCount: number;
  }

  export interface SalesCalendarResponseModel extends ManagementResponseModel {
    results: SalesCalendar[];
  }

  export interface SalesTargetResponseModel extends ManagementResponseModel {
    results: SalesTarget[];
  }

  export interface ReportingVehicleResponseModel extends ManagementResponseModel {
    results: ReportingVehicle[];
  }
